/**
 * SDUI constants for client use
 *
 * These mirror the server-side constants but are defined locally to avoid
 * CommonJS/ESM bundling issues with workspace packages.
 *
 * Keep in sync with packages/sdui-types/src/actions.ts
 */

/**
 * Maximum delay allowed for action execution (30 seconds)
 */
export const MAX_ACTION_DELAY_MS = 30000;

/**
 * Maximum number of actions allowed in a sequence
 */
export const MAX_ACTION_SEQUENCE_LENGTH = 10;
